import { useManyRefs, useResizeObserved } from '@carnica/utils/hooks';
import { useMemo } from 'react';
export var useTabBar = function useTabBar(_ref) {
  var items = _ref.items,
    value = _ref.value,
    getItemKey = _ref.getItemKey;
  var tabBarRefs = useManyRefs(items.length);
  var tabWidths = useResizeObserved(tabBarRefs, function (el) {
    var _el$offsetWidth;
    return (_el$offsetWidth = el === null || el === void 0 ? void 0 : el.offsetWidth) !== null && _el$offsetWidth !== void 0 ? _el$offsetWidth : 0;
  });
  var activeIndex = useMemo(function () {
    return value ? items.findIndex(function (item) {
      return getItemKey(item) === getItemKey(value);
    }) : -1;
  }, [items, value, tabWidths]);
  var offset = useMemo(function () {
    return tabWidths.reduce(function (acc, val, index) {
      return acc + (index < activeIndex ? val : 0);
    }, 0);
  }, [tabWidths, activeIndex]);
  return useMemo(function () {
    return {
      tabBarRefs: tabBarRefs,
      activeIndex: activeIndex,
      tabWidths: tabWidths,
      pointer: {
        width: activeIndex >= 0 ? tabWidths[activeIndex] : undefined,
        offset: offset
      }
    };
  }, [items.length, tabWidths, offset, activeIndex]);
};